export function formatAddress(address: any) {
  return address
    ? [address.address, address.city, address.state, address.zip]
        .map((item) => item?.trim())
        .filter((item) => !!item)
        .join(', ')
    : ''
}

export function formatMultilineAddress(address: {
  address?: string
  city?: string
  state?: string
  zip?: string
}) {
  let line1 = address.address ?? ''
  let line2 = `${address.city ?? ''}, ${address.state ?? ''} ${
    address.zip ?? ''
  }`.trim()

  if (line2.endsWith(',')) {
    line2 = line2.slice(0, -1) // remove trailing comma if any
  }

  if (!line1) {
    line1 = line2
    line2 = ''
  }

  return { line1, line2 }
}
